import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';

function NotFound() {
    return (
        <main className="privacy-page">
            <Helmet>
                <title>Page not found — SRL Advisor</title>
                <meta name="robots" content="noindex" />
            </Helmet>
            <Container className="privacy-container">
                <div className="text-center" style={{ padding: '6rem 0' }}>
                    <h1 className="privacy-title">Page not found</h1>
                    <p className="section-subheading mt-3 mb-4">
                        The page you're looking for doesn't exist or has been moved.
                    </p>
                    <Link to="/" className="btn-primary-cta">
                        Back to home
                        <span className="cta-arrow" aria-hidden="true">&rarr;</span>
                    </Link>
                </div>
            </Container>
        </main>
    );
}

export default NotFound;
